import {
    VIEWER_INFO,
    VIEWER_ERROR,
    VIEWER_FETCHING,
} from '../constants/actions';

const initialState = {
    fetching: false,
    error: '',
    viewer: {
        canAdd: false,
        canProcess: false,
    },
};

export default function fundingSrcReducer(state = initialState, action) {
    switch (action.type) {
        case VIEWER_FETCHING:
        return {...state,
            fetching: true,
            error: '',
        };

        case VIEWER_INFO:
        return {...state,
            fetching: false,
            viewer: action.payload,
        };

        case VIEWER_ERROR:
        return {...state,
            fetching: false,
            error: action.payload,
        };
        default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/viewer.js